import React, { useState, useCallback, useEffect, useRef } from "react";
import { connect } from "react-redux";
import "../../../../css/salesorder.css";
import ItemLotSearchFormLayout from './ItemLotSearchFormLayout';
import {
    GetLookupData, GetItemLotGridData, GetOrderDetailGridData, GetArOpenItemGridData
    , GetItemMasterGridData
} from "../../../../services/SalesOrderService";
import SalesOrderSearchResult from "./ItemLotSearchResult";
import ItemLotFilters from "./ItemLotFilters";
const ItemLotSearchUrl = "om/SaleOrder/ItemLotSearch";

const ItemLotMainTab = (props) => {
    const [dataSource, setDataSource] = useState(null);

    const searchData =  (formFields) => {
        var resultData =  GetItemLotGridData(accessToken, ItemLotSearchUrl, formFields);
        setDataSource(resultData);
    };
    var accessToken = props.oidc.user.access_token;
    return (
        <div>
            <div className="row">
                <div className="col-md-12 main-page">
                    <div id="accordion" >
                        <ItemLotFilters searchData={searchData} />
                        <SalesOrderSearchResult data={dataSource}/>                
                    </div>
                </div>
            </div>
        </div>
    );
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(ItemLotMainTab);